<section class="service-offerings">
  <div class="container">
    <div class="section-header">
      <h2>Choose the Pest Protection plan that's right for you.</h2>
      <p>Pest Control Plans Protect your home or business with reliable solutions tailored to your needs.</p>
    </div>
    
    <div class="plans-grid">
      <div class="plan-card" 
           *ngFor="let plan of servicePlans" 
           [class.popular]="plan.popular">
        
        <div class="plan-header" *ngIf="plan.popular">
          <span class="popular-badge">Most Popular</span>
        </div>
        
        <div class="plan-content">
          <h3 class="plan-name">{{ plan.name }}</h3>
          <p class="plan-subtitle">{{ plan.subtitle }}</p>
          
          <ul class="features-list">
            <li *ngFor="let feature of plan.features" class="feature-item">
              <mat-icon class="check-icon">check_circle</mat-icon>
              <span>{{ feature }}</span>
            </li>
          </ul>
          
          <button mat-raised-button 
                  class="plan-button"
                  [class.primary-button]="plan.popular"
                  (click)="plan.buttonAction()">
            {{ plan.buttonText }}
          </button>
        </div>
      </div>
    </div>
    
    <div class="bottom-cta">
      <p class="cta-text">
        Need help choosing the right pest protection plan? 
        <button mat-button class="phone-link" (click)="callPhone()">
          Call or text {{ companyConfig.getPhone().display }} — we’re happy to help.
        </button>
      </p>
    </div>
  </div>
</section>